<div class="container-fluid mt-4">

  <div class="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-2">
    <h4 class="mb-0">{{'RELEASE.TITLE' | translate}}</h4>
    @if (currentVersion) {
      <span class="badge bg-secondary">{{'RELEASE.CURRENT' | translate}} {{currentVersion}}</span>
    }
  </div>

  <div class="row">
    <div class="col-12 col-lg-9">
      @for (release of releases; track release.version) {
        <div class="card mb-3">
          <div class="card-body">
            <div class="d-flex flex-wrap justify-content-between align-items-baseline gap-2 mb-2">
              <h5 class="card-title mb-0">{{release.version}}</h5>
              <span class="text-muted small">{{release.date | date:'longDate'}}</span>
            </div>

            <p class="card-text">{{release.summaryKey | translate}}</p>

            @if (release.pointKeys.length) {
              <ul class="mb-0">
                @for (point of release.pointKeys; track point) {
                  <li>{{point | translate}}</li>
                }
              </ul>
            }
          </div>
        </div>
      } @empty {
        <p class="text-muted">{{'RELEASE.NONE' | translate}}</p>
      }
    </div>
  </div>
</div>
